export const STATE_LOOKUP = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AS": "American Samoa",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
};

export const getStateAbbreviation = ( state ) => {
  return Object.keys(STATE_LOOKUP).find(key => STATE_LOOKUP[key] === state);
}

export const getStateFromAbbreviation = ( abbreviation ) => {
  return STATE_LOOKUP[abbreviation];
}

export const DEMOCRATIC = 'Democratic';
export const REPUBLICAN = 'Republican';
export const INDEPENDENT = 'Independent';
export const DEMOCRATIC_COLOR = '#116EF0';
export const REPUBLICAN_COLOR = '#D10000';
export const INDEPENDENT_COLOR = '#32a852';
export const HOUSE = "House";
export const SENATE = "Senate";

export const IMAGE_BUCKET_BASE = "https://member-pages.s3.us-east-2.amazonaws.com/";
export const IMAGES_ENDPOINT = process.env.REACT_APP_IMAGES_ENDPOINT;
export const MEMBERS_ENDPOINT = process.env.REACT_APP_MEMBERS_ENDPOINT;
export const MEMBER_ENDPOINT = process.env.REACT_APP_MEMBER_ENDPOINT;
export const MEMBER_STATS_ENDPOINT = process.env.REACT_APP_MEMBER_STATS_ENDPOINT;
export const PARTY_STATS_ENDPOINT = process.env.REACT_APP_PARTY_STATS_ENDPOINT;
export const POLITICAL_POSITIONS_ENDPOINT = process.env.REACT_APP_POLITICAL_POSITIONS_ENDPOINT;
export const RECENT_STORIES_ENDPOINT = process.env.REACT_APP_RECENT_STORIES_ENDPOINT;

